import { render } from "./PhaseFileReadyModal.vue?vue&type=template&id=c0cf9150&scoped=true"
import script from "./PhaseFileReadyModal.vue?vue&type=script&lang=js"
export * from "./PhaseFileReadyModal.vue?vue&type=script&lang=js"

import "./PhaseFileReadyModal.vue?vue&type=style&index=0&id=c0cf9150&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0cf9150"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QTooltip,QIcon});
